export const USER_ACTIVITY_MESSAGE_INTERVAL = 1000 * 60 * 4;
export const CHECK_NOTIFICATION_LIST_UPDATED_CALL_INTERVAL = 1000 * 30;
export const MISSING_AUTHORIZATION_ERROR_MESSAGE = "Missing authorization";
export const EXPIRED_TOKEN_ERROR_MESSAGE = "Expired token";
export const TEXTS = {
  selectAllNotificationRemoveModalText: `Are you sure you want to remove All notifications from your list? Once removed, the notifications cannot be viewed again.`,
  selectSomeNotificationRemoveModalText: (length: any, word: any) => {
    return `Are you sure you want to remove ${length} ${word} from your list? Once removed, the 
    ${word} cannot be viewed again.`;
  },
  selectSingleNotificationRemoveModalText: `Are you sure you want to remove this notification from your list? Once removed, this notification cannot be viewed again`,
  removeText: `Remove`,
  markAsReadText: `Mark as read`,
  markAsUnreadText: `Mark as unread`,
  notStartedText: `Not Started`,
  inProgressText: `In Progress`,
  completedText: `Completed`,
  errorMessageNotifications: `Error while updating notifications`,
  errorMessageNoNotificationSelected: `No notification has been selected`,
  cancelText: `Cancel`,
  alertText: `Alert`,
  notificationText: `notification`,
  notificationsText: `notifications`,
  sharedPrivateFilterNotesText: `Only the creator or an admin can change a filter's visibility. If a shared filter was made private, it will no longer appear for other users.`,
  markPrivateFilterModalText: `Set to Private. Continue?`,
  markSharedFilterModalText: `Set to Shared. Continue?`,
  filterVisibilityApiPrivateSuccessMessage: `Filter marked as Private successfully`,
  filterVisibilityApiSharedSuccessMessage: `Filter marked as Shared successfully`,
  filterVisibilityApiErrorMessage: `Error while saving filters`,
  filterGetApiErrorMessage: `Error while fetching saved filters`,
  notificationStatusApiErrorMessage: `Error while updating status`,
  notificationReadUnreadApiErrorMessage: `Error while updating notification read/unread status`,
  notificationGetByIdApiErrorMessage: `Error while getting notification for provided id`,
  getAllNotificationsForProvidedCriteriaApiErrorMessage: `Error while fetching notification`,
  notificationHasUpdatesApiErrorMessage: `Error while checking for notification updates`,
  filterCodeSetApiErrorMessage: `Error while fetching filters-codeset-lookup`,
  getUserSettingsApiErrorMessage: `Error while fetching email settings`,
  updateUserSettingsApiErrorMessage: `Error while updating email settings`,
  getFiltersApiErrorMessage: `Error while fetching filters`,
  saveFiltersApiErrorMessage: `Error while saving filters`,
  getDefaultFilterApiErrorMessage: `Error while fetching default filter`,
  logoutApiErrorMessage: `Error while logging out`,
  notificationDownloadApiErrorMessage: `Error while downloading notifications`,
  getCommentsApiErrorMessage: `Error while fetching comments`,
  deleteCommentApiErrorMessage: `Error while deleting comment`,
  addCommentApiErrorMessage: `Error while adding comment`,
  updateCommentApiErrorMessage: `Error while updating comment`,
  removeNotificationFromUserViewApiErrorMessage: `Unable to remove notification from user view`,
  defaultApiErrorMessage: `Error occurred while performing API Request`,
};

export const EMAIL_FREQUENCY_VALUES = {
  fifteenMinutes: "fifteenMinutes",
  everyHour: "everyHour",
  everyHourTwentyFourHour: "everyHourTwentyFourHour",
  everyHourOfficeHour: "everyHourOfficeHour",
  onceADay: "onceADay",
  twiceADay: "twiceADay",
  threeTimesADay: "threeTimesADay",
};

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  HEAD = "HEAD",
  OPTIONS = "OPTIONS",
}
